import React, { useState } from 'react';
import AppGetIcon from '../../AppGetIcon';

import './search.css';

interface SearchProps {
  className?: any;
  classNameInput?: any;
  valueInput?: string;
  searchPlaceholder?: string;
  onChange: (value: string) => void;
  onClear: () => void;
  closeSearch?: () => void;
};

const Search: React.FC<SearchProps> = ({ onChange, closeSearch, className, classNameInput, valueInput, searchPlaceholder='Buscar' }) => {
  const [searchText, setSearchText] = useState('');
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchText(value);
    onChange(value);
  };

  const handleClearClick = () => {
    setSearchText('');
    onChange('');
  };

  return (
    <div className={`search-container ${className}`} >
      <div className={`search-input-container ${classNameInput}`}>
        {
          !closeSearch ? <AppGetIcon className="search-icon roteteIcon" name='searchHeader' /> :
            <AppGetIcon className="search-icon" name='close' fillColor='#8A8C8D' onClick={closeSearch} />
        }
        <input
          autoFocus
          type="text"
          value={valueInput ?? ''}
          onChange={handleInputChange}
          placeholder={searchPlaceholder+"..."}
        />
        {searchText.length > 0 && (
          <AppGetIcon className="search-icon search-icon-right" name='trash'
            strokeColor='#1196ce' onClick={handleClearClick} />
        )}
      </div>
    </div>
  );
};

export default Search;